webpackJsonp([17,39,40,42,43],{

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("46c388b2", content, true, {});

/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .SlideWithImage[data-v-2cf7f2ac]{width:100%;font-size:14px;color:#666;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.native .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac]{background-color:#f2f2f2}.native .SlideWithImage.slide[data-v-2cf7f2ac]{padding:2em 1em}.native .SlideWithImage .slide-content[data-v-2cf7f2ac]{-webkit-box-flex:4;-ms-flex-positive:4;flex-grow:4;width:100%;max-width:450px}.native .SlideWithImage .slide-h2[data-v-2cf7f2ac]{margin:0 0 1em;width:100%;color:#333;font-weight:400;text-align:justify}.native .SlideWithImage .slide-p[data-v-2cf7f2ac]{margin:0;text-align:justify;letter-spacing:.05em;line-height:1.75;font-weight:lighter}.native .SlideWithImage .slide-img[data-v-2cf7f2ac]{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;margin:1em auto}.native .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac]{width:100%;max-width:400px}.native .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac]{width:60%;max-width:300px}.native .SlideWithImage .slide-list[data-v-2cf7f2ac]{padding-left:18px;list-style:none}.native .SlideWithImage .slide-item[data-v-2cf7f2ac]{padding:.5em 0;position:relative}.native .SlideWithImage .slide-item[data-v-2cf7f2ac]:before{content:\"-\";position:absolute;left:-1.5em}.native .SlideWithImage .slide-button[data-v-2cf7f2ac]{display:block;margin:2em auto 3em;border:1px solid #333;padding:.5em 2em;text-decoration:none;color:inherit}.native .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac]{border-radius:20px}.native .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover{background-color:#333;color:#fff;-webkit-transition:all .2s;-webkit-transition:all .15s;transition:all .15s}@media (min-width:768px){.native .SlideWithImage[data-v-2cf7f2ac]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.native .SlideWithImage.left-image[data-v-2cf7f2ac]{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.native .SlideWithImage.left-image .slide-img[data-v-2cf7f2ac]{margin-right:4em}.native .SlideWithImage.right-image .slide-img[data-v-2cf7f2ac]{margin-left:4em}.native .SlideWithImage .slide-img[data-v-2cf7f2ac]{margin:0}}.desktop .SlideWithImage[data-v-2cf7f2ac],.smartphone .SlideWithImage[data-v-2cf7f2ac],.tablet .SlideWithImage[data-v-2cf7f2ac]{width:100%;font-size:14px;color:#666;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.desktop .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac],.smartphone .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac],.tablet .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac]{background-color:#f2f2f2}.desktop .SlideWithImage.slide[data-v-2cf7f2ac],.smartphone .SlideWithImage.slide[data-v-2cf7f2ac],.tablet .SlideWithImage.slide[data-v-2cf7f2ac]{padding:2em 1em}.desktop .SlideWithImage .slide-content[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-content[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-content[data-v-2cf7f2ac]{-webkit-box-flex:4;-ms-flex-positive:4;flex-grow:4;width:100%;max-width:450px}.desktop .SlideWithImage .slide-h2[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-h2[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-h2[data-v-2cf7f2ac]{margin:0 0 1em;width:100%;color:#333;font-weight:400;text-align:justify}.desktop .SlideWithImage .slide-p[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-p[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-p[data-v-2cf7f2ac]{margin:0;text-align:justify;letter-spacing:.05em;line-height:1.75;font-weight:lighter}.desktop .SlideWithImage .slide-img[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-img[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-img[data-v-2cf7f2ac]{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;margin:1em auto}.desktop .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac]{width:100%;max-width:400px}.desktop .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac]{width:60%;max-width:300px}.desktop .SlideWithImage .slide-list[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-list[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-list[data-v-2cf7f2ac]{padding-left:18px;list-style:none}.desktop .SlideWithImage .slide-item[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-item[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-item[data-v-2cf7f2ac]{padding:.5em 0;position:relative}.desktop .SlideWithImage .slide-item[data-v-2cf7f2ac]:before,.smartphone .SlideWithImage .slide-item[data-v-2cf7f2ac]:before,.tablet .SlideWithImage .slide-item[data-v-2cf7f2ac]:before{content:\"-\";position:absolute;left:-1.5em}.desktop .SlideWithImage .slide-button[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-button[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-button[data-v-2cf7f2ac]{display:block;margin:2em auto 3em;border:1px solid #333;padding:.5em 2em;text-decoration:none;color:inherit}.desktop .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac],.smartphone .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac]{border-radius:20px}.desktop .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover,.smartphone .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover,.tablet .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover{background-color:#333;color:#fff;-webkit-transition:all .2s;-webkit-transition:all .15s;transition:all .15s}.desktop .SlideWithImage[data-v-2cf7f2ac],.tablet .SlideWithImage[data-v-2cf7f2ac]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.desktop .SlideWithImage.left-image[data-v-2cf7f2ac],.tablet .SlideWithImage.left-image[data-v-2cf7f2ac]{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.desktop .SlideWithImage.left-image .slide-img[data-v-2cf7f2ac],.tablet .SlideWithImage.left-image .slide-img[data-v-2cf7f2ac]{margin-right:4em}.desktop .SlideWithImage.right-image .slide-img[data-v-2cf7f2ac],.tablet .SlideWithImage.right-image .slide-img[data-v-2cf7f2ac]{margin-left:4em}.desktop .SlideWithImage .slide-img[data-v-2cf7f2ac],.tablet .SlideWithImage .slide-img[data-v-2cf7f2ac]{margin:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/SlideWithImage/SlideWithImage.vue"],"names":[],"mappings":"AAmCA,yCACI,WAAY,AACZ,eAAgB,AAChB,WAAY,AACZ,4BAA6B,AAC7B,6BAA8B,AAC9B,0BAA2B,AAC3B,qBAAuB,CAC1B,AACD,uDACM,wBAA0B,CAC/B,AACD,+CACM,eAAiB,CACtB,AACD,wDACM,mBAAoB,AACpB,oBAAqB,AACrB,YAAa,AACb,WAAY,AACZ,eAAiB,CACtB,AACD,mDACM,eAAgB,AAChB,WAAY,AACZ,WAAY,AACZ,gBAAoB,AACpB,kBAAoB,CACzB,AACD,kDACM,SAAU,AACV,mBAAoB,AACpB,qBAAsB,AACtB,iBAAkB,AAClB,mBAAqB,CAC1B,AACD,oDACM,mBAAoB,AACpB,oBAAqB,AACrB,YAAa,AACb,eAAiB,CACtB,AACD,8DACQ,WAAY,AACZ,eAAiB,CACxB,AACD,6DACQ,UAAW,AACX,eAAiB,CACxB,AACD,qDACM,kBAAmB,AACnB,eAAiB,CACtB,AACD,qDACM,eAAgB,AAChB,iBAAmB,CACxB,AACD,4DACQ,YAAa,AACb,kBAAmB,AACnB,WAAa,CACpB,AACD,uDACM,cAAe,AACf,oBAAqB,AACrB,sBAAuB,AACvB,iBAAkB,AAClB,qBAAsB,AACtB,aAAe,CACpB,AACD,oEACQ,kBAAoB,CAC3B,AACD,6DACQ,sBAAuB,AACvB,WAAY,AACZ,2BAA8B,AAC9B,4BAA8B,AAC9B,mBAAsB,CAC7B,AACD,yBAmBA,yCACQ,8BAA+B,AAC/B,6BAA8B,AAC9B,uBAAwB,AACxB,kBAAoB,CAC3B,AACD,oDACU,8BAA+B,AAC/B,8BAA+B,AAC/B,+BAAgC,AAChC,0BAA4B,CACrC,AACD,+DACY,gBAAkB,CAC7B,AACD,gEACU,eAAiB,CAC1B,AACD,oDACU,QAAU,CACnB,CACA,AAyCD,gIAGI,WAAY,AACZ,eAAgB,AAChB,WAAY,AACZ,4BAA6B,AAC7B,6BAA8B,AAC9B,0BAA2B,AAC3B,qBAAuB,CAC1B,AACD,0KAGM,wBAA0B,CAC/B,AACD,kJAGM,eAAiB,CACtB,AACD,6KAGM,mBAAoB,AACpB,oBAAqB,AACrB,YAAa,AACb,WAAY,AACZ,eAAiB,CACtB,AACD,8JAGM,eAAgB,AAChB,WAAY,AACZ,WAAY,AACZ,gBAAoB,AACpB,kBAAoB,CACzB,AACD,2JAGM,SAAU,AACV,mBAAoB,AACpB,qBAAsB,AACtB,iBAAkB,AAClB,mBAAqB,CAC1B,AACD,iKAGM,mBAAoB,AACpB,oBAAqB,AACrB,YAAa,AACb,eAAiB,CACtB,AACD,+LAGQ,WAAY,AACZ,eAAiB,CACxB,AACD,4LAGQ,UAAW,AACX,eAAiB,CACxB,AACD,oKAGM,kBAAmB,AACnB,eAAiB,CACtB,AACD,oKAGM,eAAgB,AAChB,iBAAmB,CACxB,AACD,yLAGQ,YAAa,AACb,kBAAmB,AACnB,WAAa,CACpB,AACD,0KAGM,cAAe,AACf,oBAAqB,AACrB,sBAAuB,AACvB,iBAAkB,AAClB,qBAAsB,AACtB,aAAe,CACpB,AACD,iNAGQ,kBAAoB,CAC3B,AACD,4LAGQ,sBAAuB,AACvB,WAAY,AACZ,2BAA8B,AAC9B,4BAA8B,AAC9B,mBAAsB,CAC7B,AAoBD,mFAEI,8BAA+B,AAC/B,6BAA8B,AAC9B,uBAAwB,AACxB,kBAAoB,CACvB,AACD,yGAEM,8BAA+B,AAC/B,8BAA+B,AAC/B,+BAAgC,AAChC,0BAA4B,CACjC,AACD,+HAEQ,gBAAkB,CACzB,AACD,iIAEM,eAAiB,CACtB,AACD,yGAEM,QAAU,CACf","file":"SlideWithImage.vue","sourcesContent":["\n.native[data-v-2cf7f2ac] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .SlideWithImage[data-v-2cf7f2ac] {\n    width: 100%;\n    font-size: 14px;\n    color: #666;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n.native .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac] {\n      background-color: #f2f2f2;\n}\n.native .SlideWithImage.slide[data-v-2cf7f2ac] {\n      padding: 2em 1em;\n}\n.native .SlideWithImage .slide-content[data-v-2cf7f2ac] {\n      -webkit-box-flex: 4;\n      -ms-flex-positive: 4;\n      flex-grow: 4;\n      width: 100%;\n      max-width: 450px;\n}\n.native .SlideWithImage .slide-h2[data-v-2cf7f2ac] {\n      margin: 0 0 1em;\n      width: 100%;\n      color: #333;\n      font-weight: normal;\n      text-align: justify;\n}\n.native .SlideWithImage .slide-p[data-v-2cf7f2ac] {\n      margin: 0;\n      text-align: justify;\n      letter-spacing: .05em;\n      line-height: 1.75;\n      font-weight: lighter;\n}\n.native .SlideWithImage .slide-img[data-v-2cf7f2ac] {\n      -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n      flex-grow: 2;\n      margin: 1em auto;\n}\n.native .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac] {\n        width: 100%;\n        max-width: 400px;\n}\n.native .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac] {\n        width: 60%;\n        max-width: 300px;\n}\n.native .SlideWithImage .slide-list[data-v-2cf7f2ac] {\n      padding-left: 18px;\n      list-style: none;\n}\n.native .SlideWithImage .slide-item[data-v-2cf7f2ac] {\n      padding: .5em 0;\n      position: relative;\n}\n.native .SlideWithImage .slide-item[data-v-2cf7f2ac]:before {\n        content: \"-\";\n        position: absolute;\n        left: -1.5em;\n}\n.native .SlideWithImage .slide-button[data-v-2cf7f2ac] {\n      display: block;\n      margin: 2em auto 3em;\n      border: 1px solid #333;\n      padding: .5em 2em;\n      text-decoration: none;\n      color: inherit;\n}\n.native .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac] {\n        border-radius: 20px;\n}\n.native .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover {\n        background-color: #333;\n        color: #fff;\n        -webkit-transition: all 200ms;\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n}\n@media (min-width: 768px) {\n.native[data-v-2cf7f2ac] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .SlideWithImage[data-v-2cf7f2ac] {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n}\n.native .SlideWithImage.left-image[data-v-2cf7f2ac] {\n          -webkit-box-orient: horizontal;\n          -webkit-box-direction: reverse;\n          -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n}\n.native .SlideWithImage.left-image .slide-img[data-v-2cf7f2ac] {\n            margin-right: 4em;\n}\n.native .SlideWithImage.right-image .slide-img[data-v-2cf7f2ac] {\n          margin-left: 4em;\n}\n.native .SlideWithImage .slide-img[data-v-2cf7f2ac] {\n          margin: 0;\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-2cf7f2ac] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n}\n.smartphone[data-v-2cf7f2ac],\n.tablet[data-v-2cf7f2ac],\n.desktop[data-v-2cf7f2ac] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .SlideWithImage[data-v-2cf7f2ac],\n  .tablet .SlideWithImage[data-v-2cf7f2ac],\n  .desktop .SlideWithImage[data-v-2cf7f2ac] {\n    width: 100%;\n    font-size: 14px;\n    color: #666;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n.smartphone .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac],\n    .tablet .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac],\n    .desktop .SlideWithImage.slide-bg-gray[data-v-2cf7f2ac] {\n      background-color: #f2f2f2;\n}\n.smartphone .SlideWithImage.slide[data-v-2cf7f2ac],\n    .tablet .SlideWithImage.slide[data-v-2cf7f2ac],\n    .desktop .SlideWithImage.slide[data-v-2cf7f2ac] {\n      padding: 2em 1em;\n}\n.smartphone .SlideWithImage .slide-content[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-content[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-content[data-v-2cf7f2ac] {\n      -webkit-box-flex: 4;\n      -ms-flex-positive: 4;\n      flex-grow: 4;\n      width: 100%;\n      max-width: 450px;\n}\n.smartphone .SlideWithImage .slide-h2[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-h2[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-h2[data-v-2cf7f2ac] {\n      margin: 0 0 1em;\n      width: 100%;\n      color: #333;\n      font-weight: normal;\n      text-align: justify;\n}\n.smartphone .SlideWithImage .slide-p[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-p[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-p[data-v-2cf7f2ac] {\n      margin: 0;\n      text-align: justify;\n      letter-spacing: .05em;\n      line-height: 1.75;\n      font-weight: lighter;\n}\n.smartphone .SlideWithImage .slide-img[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-img[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-img[data-v-2cf7f2ac] {\n      -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n      flex-grow: 2;\n      margin: 1em auto;\n}\n.smartphone .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac],\n      .tablet .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac],\n      .desktop .SlideWithImage .slide-img.landscape[data-v-2cf7f2ac] {\n        width: 100%;\n        max-width: 400px;\n}\n.smartphone .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac],\n      .tablet .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac],\n      .desktop .SlideWithImage .slide-img.portrait[data-v-2cf7f2ac] {\n        width: 60%;\n        max-width: 300px;\n}\n.smartphone .SlideWithImage .slide-list[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-list[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-list[data-v-2cf7f2ac] {\n      padding-left: 18px;\n      list-style: none;\n}\n.smartphone .SlideWithImage .slide-item[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-item[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-item[data-v-2cf7f2ac] {\n      padding: .5em 0;\n      position: relative;\n}\n.smartphone .SlideWithImage .slide-item[data-v-2cf7f2ac]:before,\n      .tablet .SlideWithImage .slide-item[data-v-2cf7f2ac]:before,\n      .desktop .SlideWithImage .slide-item[data-v-2cf7f2ac]:before {\n        content: \"-\";\n        position: absolute;\n        left: -1.5em;\n}\n.smartphone .SlideWithImage .slide-button[data-v-2cf7f2ac],\n    .tablet .SlideWithImage .slide-button[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-button[data-v-2cf7f2ac] {\n      display: block;\n      margin: 2em auto 3em;\n      border: 1px solid #333;\n      padding: .5em 2em;\n      text-decoration: none;\n      color: inherit;\n}\n.smartphone .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac],\n      .tablet .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac],\n      .desktop .SlideWithImage .slide-button.round-button[data-v-2cf7f2ac] {\n        border-radius: 20px;\n}\n.smartphone .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover,\n      .tablet .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover,\n      .desktop .SlideWithImage .slide-button[data-v-2cf7f2ac]:hover {\n        background-color: #333;\n        color: #fff;\n        -webkit-transition: all 200ms;\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n}\n.tablet[data-v-2cf7f2ac],\n.desktop[data-v-2cf7f2ac] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.tablet .SlideWithImage[data-v-2cf7f2ac],\n  .desktop .SlideWithImage[data-v-2cf7f2ac] {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n.tablet .SlideWithImage.left-image[data-v-2cf7f2ac],\n    .desktop .SlideWithImage.left-image[data-v-2cf7f2ac] {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n}\n.tablet .SlideWithImage.left-image .slide-img[data-v-2cf7f2ac],\n      .desktop .SlideWithImage.left-image .slide-img[data-v-2cf7f2ac] {\n        margin-right: 4em;\n}\n.tablet .SlideWithImage.right-image .slide-img[data-v-2cf7f2ac],\n    .desktop .SlideWithImage.right-image .slide-img[data-v-2cf7f2ac] {\n      margin-left: 4em;\n}\n.tablet .SlideWithImage .slide-img[data-v-2cf7f2ac],\n    .desktop .SlideWithImage .slide-img[data-v-2cf7f2ac] {\n      margin: 0;\n}\n.desktop[data-v-2cf7f2ac] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SlideWithImage.l.scss": 1137,
	"./SlideWithImage.m.scss": 1139,
	"./SlideWithImage.s.scss": 1141,
	"./SlideWithImage.scss": 1143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1136;

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1138);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1140);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".SlideWithImage{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.SlideWithImage.left-image{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.SlideWithImage.left-image .slide-img{margin-right:4em}.SlideWithImage.right-image .slide-img{margin-left:4em}.SlideWithImage .slide-img{margin:0}", ""]);

// exports


/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1142);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".SlideWithImage{width:100%;font-size:14px;color:#666;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.SlideWithImage.slide-bg-gray{background-color:#f2f2f2}.SlideWithImage.slide{padding:2em 1em}.SlideWithImage .slide-content{-webkit-box-flex:4;-ms-flex-positive:4;flex-grow:4;width:100%;max-width:450px}.SlideWithImage .slide-h2{margin:0 0 1em;width:100%;color:#333;font-weight:400;text-align:justify}.SlideWithImage .slide-p{margin:0;text-align:justify;letter-spacing:.05em;line-height:1.75;font-weight:lighter}.SlideWithImage .slide-img{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;margin:1em auto}.SlideWithImage .slide-img.landscape{width:100%;max-width:400px}.SlideWithImage .slide-img.portrait{width:60%;max-width:300px}.SlideWithImage .slide-list{padding-left:18px;list-style:none}.SlideWithImage .slide-item{padding:.5em 0;position:relative}.SlideWithImage .slide-item:before{content:\"-\";position:absolute;left:-1.5em}.SlideWithImage .slide-button{display:block;margin:2em auto 3em;border:1px solid #333;padding:.5em 2em;text-decoration:none;color:inherit}.SlideWithImage .slide-button.round-button{border-radius:20px}.SlideWithImage .slide-button:hover{background-color:#333;color:#fff;-webkit-transition:all .2s;-webkit-transition:all .15s;transition:all .15s}", ""]);

// exports


/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1144);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".SlideWithImage{width:100%;font-size:14px;color:#666;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.SlideWithImage.slide-bg-gray{background-color:#f2f2f2}.SlideWithImage.slide{padding:2em 1em}.SlideWithImage .slide-content{-webkit-box-flex:4;-ms-flex-positive:4;flex-grow:4;width:100%;max-width:450px}.SlideWithImage .slide-h2{margin:0 0 1em;width:100%;color:#333;font-weight:400;text-align:justify}.SlideWithImage .slide-p{margin:0;text-align:justify;letter-spacing:.05em;line-height:1.75;font-weight:lighter}.SlideWithImage .slide-img{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;margin:1em auto}.SlideWithImage .slide-img.landscape{width:100%;max-width:400px}.SlideWithImage .slide-img.portrait{width:60%;max-width:300px}.SlideWithImage .slide-list{padding-left:18px;list-style:none}.SlideWithImage .slide-item{padding:.5em 0;position:relative}.SlideWithImage .slide-item:before{content:\"-\";position:absolute;left:-1.5em}.SlideWithImage .slide-button{display:block;margin:2em auto 3em;border:1px solid #333;padding:.5em 2em;text-decoration:none;color:inherit}.SlideWithImage .slide-button.round-button{border-radius:20px}.SlideWithImage .slide-button:hover{background-color:#333;color:#fff;-webkit-transition:all .2s;-webkit-transition:all .15s;transition:all .15s}@media (min-width:768px){.SlideWithImage{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.SlideWithImage.left-image{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.SlideWithImage.left-image .slide-img{margin-right:4em}.SlideWithImage.right-image .slide-img{margin-left:4em}.SlideWithImage .slide-img{margin:0}}", ""]);

// exports


/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.isEditing}}},[_c('section',{class:['SlideWithImage', 'theme-base-bg-color', 'flex', 'justify-center', 'items-center', 'slide', _vm.contents.image.position === 'left' ? 'left-image row-reverse-tablet' : 'right-image'],style:(_vm.contents.bg.isCustom ? 'background-color:' + _vm.contents.bg.color : '')},[_c('div',{staticClass:"slide-content flex column justify-center"},[_c('h2',{staticClass:"slide-h2"},[_vm._v(_vm._s(_vm.contents.heading.text))]),_vm._v(" "),_c('p',{staticClass:"slide-p pre-wrap"},[_vm._v(_vm._s(_vm.contents.paragraph.text))]),_vm._v(" "),(_vm.contents.list && _vm.contents.list.length > 0 && _vm.contents.list.reduce(function (p, c) { return p + c; }, '') !== '')?[_c('ul',{staticClass:"slide-list"},[_vm._l((_vm.contents.list),function(item,index){return [_c('li',{key:index,staticClass:"slide-item"},[_vm._v(_vm._s(item))])]})],2)]:_vm._e(),_vm._v(" "),(_vm.contents.link.text && _vm.contents.link.href)?[_c('a',{class:['slide-button', _vm.contents.link.form + '-button']},[_vm._v(_vm._s(_vm.contents.link.text))])]:_vm._e()],2),_vm._v(" "),_c('div',{class:['amp-img', 'slide-img', 'amp-img-cover', _vm.contents.image.width > _vm.contents.image.height ? 'landscape' : 'portrait']},[_c('mimic-amp-img',{attrs:{"image":_vm.contents.image}})],1)])])]),_vm._v(" "),_c('el-dialog',{attrs:{"width":"90%","title":"画像の選択","visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('select-image',{on:{"change":_vm.onUpdateImage},model:{value:(_vm.selectedImage),callback:function ($$v) {_vm.selectedImage=$$v},expression:"selectedImage"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdateImage}},[_vm._v("選択")])],1)],1),_vm._v(" "),_c('el-form',{class:['component-contents-form', ' p2', _vm.lock ? 'hide' : _vm.isEditing ? 'show' : 'hide'],attrs:{"model":_vm.contents}},[_c('h2',[_vm._v("コンポーネントのコンテンツを編集")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"コンポーネント配置順序","label-width":"170px"}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":_vm.positionMax},model:{value:(_vm.newPosition),callback:function ($$v) {_vm.newPosition=$$v},expression:"newPosition"}}),_c('span',{staticClass:"pl4"},[_vm._v("1から"+_vm._s(_vm.positionMax)+"まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"見出し","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.heading.text),callback:function ($$v) {_vm.$set(_vm.contents.heading, "text", $$v)},expression:"contents.heading.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"段落","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.paragraph.text),callback:function ($$v) {_vm.$set(_vm.contents.paragraph, "text", $$v)},expression:"contents.paragraph.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リスト","label-width":_vm.labelWidth}},_vm._l((_vm.contents.list),function(item,index){return _c('el-input',{key:index,staticClass:"width-75",attrs:{"type":"input","auto-complete":"off"},model:{value:(_vm.contents.list[index]),callback:function ($$v) {_vm.$set(_vm.contents.list, index, $$v)},expression:"contents.list[index]"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-delete"},on:{"click":function($event){_vm.contents.list.splice(index, 1)}},slot:"append"})],1)})),_vm._v(" "),_c('el-button',{style:('margin:0 0 30px ' + _vm.labelWidth),on:{"click":function($event){_vm.contents.list.push('')}}},[_vm._v("リスト項目の追加")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンクテキスト","label-width":_vm.labelWidth}},[_c('el-input',{staticClass:"width-75",attrs:{"auto-complete":"off"},model:{value:(_vm.contents.link.text),callback:function ($$v) {_vm.$set(_vm.contents.link, "text", $$v)},expression:"contents.link.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンク先URL","label-width":_vm.labelWidth}},[_c('el-input',{staticClass:"width-75",attrs:{"auto-complete":"off"},model:{value:(_vm.contents.link.href),callback:function ($$v) {_vm.$set(_vm.contents.link, "href", $$v)},expression:"contents.link.href"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンクボタンの形状","label-width":_vm.labelWidth}},[_c('el-radio-group',{model:{value:(_vm.contents.link.form),callback:function ($$v) {_vm.$set(_vm.contents.link, "form", $$v)},expression:"contents.link.form"}},[_c('el-radio-button',{attrs:{"disabled":_vm.contents.link.text === '' || _vm.contents.link.href === '',"label":"round"}},[_vm._v("楕円ボタン")]),_vm._v(" "),_c('el-radio-button',{attrs:{"disabled":_vm.contents.link.text === '' || _vm.contents.link.href === '',"label":"square"}},[_vm._v("四角ボタン")])],1)],1),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.onSelectImage(_vm.contents.image)}}},[_vm._v("画像の選択")]),_vm._v(" "),_c('div',{staticClass:"image-info flex column justify-between items-center"},[_c('img',{staticClass:"image-info-img",attrs:{"src":_vm.contents.image.src}}),_vm._v(" "),_c('p',{staticClass:"image-info-size"},[_vm._v("画像のサイズ："+_vm._s(_vm.contents.image.width)+"x"+_vm._s(_vm.contents.image.height))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"画像の配置場所","label-width":_vm.labelWidth}},[_c('el-radio-group',{model:{value:(_vm.contents.image.position),callback:function ($$v) {_vm.$set(_vm.contents.image, "position", $$v)},expression:"contents.image.position"}},[_c('el-radio-button',{attrs:{"label":"left"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"right"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.bg.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.bg, "isCustom", $$v)},expression:"contents.bg.isCustom"}},[_vm._v("スライドの背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.bg.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.bg.color),callback:function ($$v) {_vm.$set(_vm.contents.bg, "color", $$v)},expression:"contents.bg.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.bg.color))])],1)]),_vm._v(" "),_c('div',{staticClass:"component-contents-controller flex justify-end items-center"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0f36de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectImage_vue__ = __webpack_require__(458);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28312d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectImage_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28312d60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28312d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideWithImage_vue__ = __webpack_require__(814);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf7f2ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideWithImage_vue__ = __webpack_require__(1145);
function injectStyle (ssrContext) {
  __webpack_require__(1134)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cf7f2ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideWithImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf7f2ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideWithImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-img',
  props: ['image']
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-image',
  props: ['value'],
  data: function data() {
    return {
      selected: { id: 0 }
    };
  },
  // watch: {
  //   /**
  //    * @see https://stackoverflow.com/questions/40915436/vuejs-update-parent-data-from-child-component/40915910
  //    */
  //   selected: function (newVal, oldVal) {
  //     console.log('%cnewValue = ' + JSON.stringify(newVal), 'color:red')
  //     console.log('%coldValue = ' + JSON.stringify(oldVal), 'color:red')
  //     this.selected.id = newVal.id
  //     this.$emit('input', this.selected)
  //   }
  // },
  computed: {
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    }
  },
  created: function created() {
    if (false) console.log('On SelectImage created...');
    // if (process.env.NODE_ENV !== 'production') console.log(this.media)
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.id))
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.media_details.sizes.thumbnail))

    this.selected = this.value;
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("2434fe00", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-img[data-v-7e0f36de]{display:block;width:100%;position:relative;overflow:hidden!important}.amp-img-sizer[data-v-7e0f36de]{display:block!important}.amp-img-content[data-v-7e0f36de]{display:block;margin:auto;border:none!important;padding:0!important;width:0;max-width:100%;min-width:100%;height:0;max-height:100%;min-height:100%;position:absolute;top:0;left:0;right:0;bottom:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpImg.vue"],"names":[],"mappings":"AAsBA,0BACE,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,yBAA4B,CAC7B,AACD,gCACI,uBAA0B,CAC7B,AACD,kCACI,cAAe,AACf,YAAa,AACb,sBAAwB,AACxB,oBAAsB,AACtB,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,QAAU,CACb","file":"MimicAmpImg.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-img[data-v-7e0f36de] {\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden !important;\n}\n.amp-img-sizer[data-v-7e0f36de] {\n    display: block !important;\n}\n.amp-img-content[data-v-7e0f36de] {\n    display: block;\n    margin: auto;\n    border: none !important;\n    padding: 0 !important;\n    width: 0;\n    max-width: 100%;\n    min-width: 100%;\n    height: 0;\n    max-height: 100%;\n    min-height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-img"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.image.height / _vm.image.width * 100 + '%')}),_vm._v(" "),_c('img',{staticClass:"amp-img-content",attrs:{"src":_vm.image.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("b7ba9072", content, true, {});

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".image[data-v-28312d60]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.image-list[data-v-28312d60]{border:1px solid #ddd;height:180px;min-height:50vh;overflow:scroll}.image-item-input[data-v-28312d60]{display:none}.image-item-input:checked+.image-item-label[data-v-28312d60]:after{border:3px solid #569cf3}.image-item-label[data-v-28312d60]{display:block;width:139px;height:139px;position:relative}.image-item-label[data-v-28312d60]:after{content:\"\";display:block;width:100%;height:100%;position:absolute;top:0;left:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/app/SelectImage.vue"],"names":[],"mappings":"AAsBA,wBACE,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,gBAAkB,CACtB,AACD,6BACI,sBAAuB,AACvB,aAAc,AACd,gBAAiB,AACjB,eAAiB,CACpB,AACD,mCACI,YAAc,CACjB,AACD,mEACM,wBAA0B,CAC/B,AACD,mCACI,cAAe,AACf,YAAa,AACb,aAAc,AACd,iBAAmB,CACtB,AACD,yCACM,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACb","file":"SelectImage.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.image[data-v-28312d60] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.image-list[data-v-28312d60] {\n    border: 1px solid #ddd;\n    height: 180px;\n    min-height: 50vh;\n    overflow: scroll;\n}\n.image-item-input[data-v-28312d60] {\n    display: none;\n}\n.image-item-input:checked + .image-item-label[data-v-28312d60]:after {\n      border: 3px solid #569cf3;\n}\n.image-item-label[data-v-28312d60] {\n    display: block;\n    width: 139px;\n    height: 139px;\n    position: relative;\n}\n.image-item-label[data-v-28312d60]:after {\n      content: \"\";\n      display: block;\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.media)?[_c('ul',{staticClass:"image-list flex wrap"},[_vm._l((_vm.media),function(image,index){return [_c('li',{key:index,staticClass:"image-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.id),expression:"selected.id"}],staticClass:"image-item-input",attrs:{"type":"radio","id":_vm._uid + '-' + image.id},domProps:{"value":image.id,"checked":_vm._q(_vm.selected.id,image.id)},on:{"change":function($event){_vm.$set(_vm.selected, "id", image.id)}}}),_vm._v(" "),_c('label',{staticClass:"image-item-label",attrs:{"for":_vm._uid + '-' + image.id}},[_c('img',{staticClass:"image",attrs:{"src":image.media_details.sizes.thumbnail.source_url}})])])]})],2)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpImg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_SelectImage__ = __webpack_require__(135);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide-with-image',
  components: {
    'mimic-amp-img': __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpImg__["default"],
    'select-image': __WEBPACK_IMPORTED_MODULE_2__components_app_SelectImage__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__["default"]],
  data: function data() {
    return {
      labelWidth: '11em',
      selectedImage: {
        id: null,
        src: null,
        width: null,
        height: null
      },
      dialogFormVisible: false
    };
  },
  watch: {
    selectedImage: function selectedImage(newVal) {
      console.log(newVal);
    }
  },
  methods: {
    /**
     * 「画像の選択」ボタンがクリックされたら、contents.imageの各プロパティを
     * this.selectedImageにコピーする
     */
    onSelectImage: function onSelectImage(image) {
      var found = this.media.find(function (img) {
        return img.source_url === image.src;
      });
      if (false) console.log(found);
      image.id = found ? found.id : 0;

      this.selectedImage.id = image.id;
      this.selectedImage.src = image.src;
      this.selectedImage.width = image.width;
      this.selectedImage.height = image.height;
      this.dialogFormVisible = true;
    },
    /**
     * ダイアログで画像を選択したら、選択した画像をidを元にthis.mediaから探し、
     * その画像の情報をthis.contents.imageに格納する
     */
    onUpdateImage: function onUpdateImage() {
      var _this = this;

      var selected = this.media.find(function (image) {
        return image.id === _this.selectedImage.id;
      });
      this.contents.image.id = selected.id;
      this.contents.image.src = selected.source_url;
      this.contents.image.width = selected.media_details.width;
      this.contents.image.height = selected.media_details.height;
      this.dialogFormVisible = false;
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var ul = '';
      if (contents.list && contents.list.length > 0 && contents.list.reduce(function (p, c) {
        return p + c;
      }, '')) {
        ul += '<ul class="slide-list">';
        contents.list.forEach(function (item) {
          ul += '<li class="slide-item">' + item + '</li>';
        });
        ul += '</ul>';
      }
      var anchor = '';
      if (contents.link.text && contents.link.href) {
        anchor += '<a class="slide-button ' + contents.link.form + '-button" href="' + contents.link.href + '">' + contents.link.text + '</a>';
      }
      var imageDirection = contents.image.width > contents.image.height ? 'landscape' : 'portrait';

      var imagePlace = contents.image.position === 'left' ? 'left-image row-reverse-tablet' : 'right-image';

      var html = '\n        <section id="' + this.sectionId + '" class="' + this.meta.file + ' flex column row-tablet justify-center items-center slide ' + imagePlace + ' ' + (contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + '">\n          <div class="slide-content flex column justify-center">\n            <h2 class="slide-h2">' + contents.heading.text + '</h2>\n            <p class="slide-p pre-wrap">' + contents.paragraph.text + '</p>\n            ' + ul + '\n            ' + anchor + '\n          </div>\n          <amp-img class="slide-img amp-img-cover ' + imageDirection + '" width="' + contents.image.width + '" height="' + contents.image.height + '" layout="responsive" src="' + contents.image.src + '"></amp-img>\n        </section>';

      return html.replace(/>\s+</g, '><');
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(1136)("./" + this.meta.file + '.scss');
      var theme = contents.bg.isCustom ? '.' + this.meta.file + '-' + this._uid + '-bg{background-color:' + contents.bg.color + '}' : '';
      return { layout: layout, theme: theme };
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.b59f633444747dfd6b61.js